// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";

function Input(Props) {
  var id = Props.id;
  var value = Props.value;
  var onChange = Props.onChange;
  return React.createElement("input", {
              className: "input",
              id: id,
              value: value,
              onChange: (function ($$event) {
                  return Curry._1(onChange, $$event.target.value);
                })
            });
}

var make = Input;

export {
  make ,
  
}
/* react Not a pure module */
